import type { ProjectScope } from './project-scope';

const pendingNoteWriteKeys = new Set<string>();
const pendingNoteDeleteKeys = new Set<string>();

function noteWriteKey(scope: ProjectScope, noteId: string): string {
    return `${scope.orgId}\0${scope.projectId}\0${noteId}`;
}

function noteWritePrefix(scope: ProjectScope): string {
    return `${scope.orgId}\0${scope.projectId}\0`;
}

export function markPendingNoteWrite(scope: ProjectScope, noteId: string): void {
    pendingNoteDeleteKeys.delete(noteWriteKey(scope, noteId));
    pendingNoteWriteKeys.add(noteWriteKey(scope, noteId));
}

export function markPendingNoteDelete(scope: ProjectScope, noteId: string): void {
    pendingNoteWriteKeys.delete(noteWriteKey(scope, noteId));
    pendingNoteDeleteKeys.add(noteWriteKey(scope, noteId));
}

export function clearPendingNoteWrite(scope: ProjectScope, noteId: string): void {
    pendingNoteWriteKeys.delete(noteWriteKey(scope, noteId));
}

export function isPendingNoteWrite(scope: ProjectScope, noteId: string): boolean {
    return pendingNoteWriteKeys.has(noteWriteKey(scope, noteId));
}

export function isPendingNoteDelete(scope: ProjectScope, noteId: string): boolean {
    return pendingNoteDeleteKeys.has(noteWriteKey(scope, noteId));
}

export function clearAcknowledgedPendingNoteDeletes(scope: ProjectScope, remoteNoteIds: ReadonlySet<string>): void {
    const prefix = noteWritePrefix(scope);
    for (const key of Array.from(pendingNoteDeleteKeys)) {
        if (!key.startsWith(prefix)) continue;
        const noteId = key.slice(prefix.length);
        if (!remoteNoteIds.has(noteId)) {
            pendingNoteDeleteKeys.delete(key);
        }
    }
}

export function clearPendingNoteWrites(): void {
    pendingNoteWriteKeys.clear();
    pendingNoteDeleteKeys.clear();
}
